/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/interactive-supports-focus */

import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import MediaCarousel from 'dpl/components/MediaCarousel';
import PhotoAlbumThumbnailButton from 'dpl/components/PhotoAlbum/PhotoAlbumThumbnailButton';
import { PHOTO_ALBUM_CATEGORIES_HEIGHT } from 'dpl/constants/photo_album';
import { noop } from 'dpl/shared/utils';
import { LitterPhotographPropTypes } from 'dpl/shared/utils/customPropTypes';

const photoAlbumDefaultPropImageCategories = [];
/** @param {any} props */
export default function PhotoAlbum({
  setImage,
  onClose,
  currentImage,
  imagesOrderedByCategory,
  imageCategories = photoAlbumDefaultPropImageCategories,
  getFirstImageForCategory = noop,
  renderPhotoDetails = noop
}) {
  return (
    <MiniOverlayModal
      scrollableContent
      onCloseClick={onClose}
      maxWidth="100%"
      contentClassName="bg-black-90 overflow-hidden ph5-md"
      fullScreen
    >
      <div className="h-100 flex flex-column bg-black-90 ph5 pb5">
        <div
          className="bg-black-90 overflow-hidden ph6 flex align-items-end mt4 mt0-md"
          style={{ flex: `0 0 ${PHOTO_ALBUM_CATEGORIES_HEIGHT}px` }}
        >
          <ul className="nowrap overflow-auto no-scrollbars nh4">
            {imageCategories.length > 0 &&
              imageCategories.map(category => (
                <li
                  key={category}
                  className={classnames('transition dib bb fw-medium font-16', {
                    'b--white white': currentImage.category === category,
                    'b--transparent secondary':
                      currentImage.category !== category
                  })}
                >
                  <a
                    className="pv2 ph3 db"
                    onClick={e => {
                      e.preventDefault();
                      setImage(getFirstImageForCategory(category).id);
                    }}
                    role="button"
                  >
                    {category}
                  </a>
                </li>
              ))}
          </ul>
        </div>
        <div className="flex-auto w-100 h-100 flex flex-column">
          <div className="flex-auto relative">
            <div className="w-100 h-100 absolute bg-black-90 pv10-md pv5">
              <MediaCarousel
                renderFileDetails={renderPhotoDetails}
                lazy={false}
                files={imagesOrderedByCategory}
                onFileChange={setImage}
                currentFile={currentImage}
                bulletsContainerClassName="d-none"
                smartImageProps={{
                  className:
                    'transform-center left-0 bottom-0 right-0 top-0 max-h-100 h-100 h-auto center',
                  wrapperOnlyClassName: 'w-100',
                  imageOnlyClassName: 'max-h-100 h-auto',
                  loadingClass: 'w-100 loading-spinner',
                  alt: currentImage.caption || currentImage.alt_text
                }}
              />
            </div>
          </div>
          <ul className="flex overflow-x-auto w-100">
            {imagesOrderedByCategory.map(image => (
              <li className="f0" key={image.id}>
                <PhotoAlbumThumbnailButton
                  onClick={() => setImage(image.id)}
                  isSelected={image === currentImage}
                  image={image}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </MiniOverlayModal>
  );
}

PhotoAlbum.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  imagesOrderedByCategory: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  setImage: PropTypes.func.isRequired,
  currentImage: PropTypes.shape(LitterPhotographPropTypes).isRequired,
  imageCategories: PropTypes.arrayOf(PropTypes.string),
  getFirstImageForCategory: PropTypes.func,
  renderPhotoDetails: PropTypes.func
};
